import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import API from "../../../Services/BaseService";
import CommonPopup from "../../../Component/CommonPopup/CommonPopup";
import { useDispatch, useSelector } from "react-redux";
import ls from "local-storage";
import StateAndCity from "../../../Component/StateAndCity/StateAndCity";
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import Loading from "../../../Component/Loading/Loading";

const MailLogAdd = (props) => {
  const history = useHistory();
  const [loading, setloading] = useState(true);

  const yesterday = moment().subtract(1, 'day');
  const disablePastDt = current => {
    return current.isAfter(yesterday);
  };

  const [address,setAddress] = useState("");
  const [organization,setOrganization] = useState("");
  const [stateName,setStateName] = useState("");
  const [cityName,setCityName] = useState("");
  const [zipcode,setZipcode] = useState("");
  const [trackingId,setTrackingId] = useState("");
  const [checkId,setCheckId] = useState("");
  const [sendToName,setSendToName] = useState("");
  const [sendToId,setSendToId] = useState("");
  const [itemSent,setItemSent] = useState("");
  const [mailLogList, setMailLogList] = useState("");
  const [dateSent,setDateSent] = useState("");
  const [otherSent,setOtherSent] = useState("");
  const [bankList, setBankList] = useState("");
  const [bankId, setBankId] = useState("");
  const [sentViaList, setSentViaList] = useState("");
  const [sentViaId, setSentViaId] = useState("");
  const [comments,setComments] = useState("");
  
  useEffect(() => {
    getCustomerDetails();
    mailBankAccount();
  }, []);

  const getCustomerDetails = () => {
    let request ={
        maillog_details_id : props.mailLogDetailsId
    }
    API.post("maillogdetailsviewbyid/condition", request).then((response) => {
      console.log("mailBankAccount", response.data.data[0]);
      setMailLogList(response.data.data[0]);
      setItemSent(response.data.data[0]?.item_sent);
      setOtherSent(response.data.data[0]?.item_sent_others);
      setDateSent(response.data.data[0]?.date_sent);
      setSentViaId(response.data.data[0]?.maillog_sent_item);
      setTrackingId(response.data.data[0]?.tracking);
      setBankId(response.data.data[0]?.bank_account_name);
      setCheckId(response.data.data[0]?.checks);
      setComments(response.data.data[0]?.comments);
      setSendToName(response.data.data[0]?.sent_name);
      setSendToId(response.data.data[0]?.organisation);
      setAddress(response.data.data[0]?.address);
      setOrganization(response.data.data[0]?.sent_to_organisation);
      setStateName(response.data.data[0]?.state_name);
      setCityName(response.data.data[0]?.city_name);
      setZipcode(response.data.data[0]?.zipcode);
      setloading(false);

    });
  };
  const inputProps = {
    placeholder: "YYYY/MM/DD",
    value : dateSent,
    disabled : true
  };

  const getDate = (event) => {
    if (event._isAMomentObject == true) {

    setDateSent(event.format("YYYY/MM/DD"))
  }
}
  
  const mailBankAccount = () => {
    API.post("bankaccount/condition").then((response) => {
      console.log("mailBankAccount", response.data.data);
      setBankList(response.data.data);
      setloading(false);

    });
  };

  return (
    <div class="modal-content custom-radiobtn ">
        {loading ? <Loading />:
    <div class="modal-body ">
                <h4
                class="text-color border-bottom pb-3 mb-0 text-center">
                view Mail Log</h4>
            <div class="p-3">
            <div class="row">
            <div class="mb-2 col-md-6 col-lg-6">
                <label for="dealershipname" class="form-label">Mail Log Details #</label>
                <input type="text" class="form-control" id="dealershipname"  value={props.mailLogDetailsId} disabled/>
            </div>
            <div class="d-flex mt-4 col-lg-12">
                      <h5 class="text-color mb-4  ">Item Sent</h5>
                    </div>

                <div class="mb-2 col-md-12 col-lg-12 d-flex align-items-center">

                <div class="form-check form-check-inline me-5">
                <input
                    class="form-check-input " 
                    type="radio"
                    name="flexRadioDefault" checked={itemSent == "title" ? true : false}
                    id="Title" 
                />
                <label class="form-check-label ms-2" for="title">
                    Title
                </label>
                </div>

                <div class="form-check form-check-inline me-5">
                <input
                    class="form-check-input "
                    type="radio"
                    name="flexRadioDefault" checked={itemSent == "check" ? true : false}
                    id="Check" 
                />
                <label class="form-check-label ms-2" for="Check">
                    Check
                </label>
                </div>

                <div class="form-check form-check-inline">
                <input
                    class="form-check-input "
                    type="radio"
                    name="flexRadioDefault" checked={itemSent == "other" ? true : false}
                    id="Others" 
                />
                <label class="form-check-label ms-2" for="Others">
                    Others
                </label>
                </div>

                </div>
                {itemSent == "other" ?
                <div class="mb-2 col-md-6 col-lg-4">
                    <label for="customer#" class="form-label"></label>
                    <input type="text" class="form-control"disabled id="customer#" value={otherSent} />
                </div>:""}
{/* -------------------mail info---------------------------- */}
                      <div class="d-flex mt-4 col-lg-12">

                <h5 class="text-color mb-4">Mail Information</h5>
                    </div>
                    <div class="mb-2 col-md-6 col-lg-4">
                  <label for="completeddate" class="form-label  ">
                    Sent By
                  </label>
                  <input
                    type="text"disabled
                    class="form-control" value={sendToName}
                    id="completeddate" 
                  />
                </div>
                <div class="mb-2 col-md-6 col-lg-4 datePickerBlock">
                <label for="saledate" class="form-label  ">
                Sent Date 
                </label>
                <Datetime inputProps={ inputProps } timeFormat={false} dateFormat="YYYY/MM/DD" 
                              closeOnSelect={true}  name="Date" isValidDate={disablePastDt} onChange={getDate} 
                                id="meeting_date"/>
                </div>

                {/* <div class="mb-2 col-md-6 col-lg-4">
                <label for="customer#" class="form-label">
                    Sent By
                </label>
                <input type="number" class="form-control" id="customer#" />
                </div> */}
                
                <div class="mb-2 col-md-6 col-lg-4">
                <label for="BankAcc" class="form-label  ">Sent Via</label>
                <select class="form-select" aria-label="Default select example" id="BankAcc"disabled >

                <option style={{"display":"none" }}>{sentViaId}</option>

                {sentViaList.length>0 &&
                <>
                {sentViaList.map((sentViaList) => <option key={sentViaList.maillog_sent_item_id} value={sentViaList.maillog_sent_item_id}  >

{sentViaList.maillog_sent_item}</option>)}
                </>
                }

                </select>

                </div>
                <div class="mb-2 col-md-6 col-lg-4">
                <label for="address" class="form-label  ">
                    Tracking #
                </label>
                <input type="text" class="form-control" id="address" disabled value={trackingId} />
                </div>
                {itemSent == "check" ?
                <>
                <div class="mb-2 col-md-6 col-lg-4">
                <label for="BankAcc" class="form-label  ">Bank Account</label>
                <select class="form-select" aria-label="Default select example"disabled id="BankAcc" >

                <option style={{"display":"none" }}>{bankId}</option>

                {bankList.length>0 &&
                    <>
                        {bankList.map((bankList) => <option key={bankList.bank_account_id} value={bankList.bank_account_id}  >

{bankList.bank_account_name}</option>)}
                    </>
                }
                </select>

                </div>
                <div class="mb-2 col-md-6 col-lg-4">
                <label for="address" class="form-label  ">
                    Check #
                </label>
                <input type="text" class="form-control  " id="address" disabled value={checkId}  />
                </div>
                </>:""}
                <div class="mb-2 col-md-6 col-lg-4">
                    <label for="address" class="form-label">
                      Comments
                    </label>
                    <input type="text" class="form-control" id="address" value={comments} disabled/>
                  </div>
    {/* ------------------Send To----------------------- */}
             <div class="d-flex mt-4 col-lg-12">
                <h5 class="text-color  mb-4">Send To</h5>
                    </div>
                   
                <div class="mb-2 col-md-6 col-lg-4">
                <label for="completeddate" class="form-label  ">
                    Address
                </label>
                <input
                    type="text"disabled
                    class="form-control" value={address}
                    id="completeddate" 
                />
                </div>
                
                <div class="mb-2 col-md-6 col-lg-4">
                    <label for="country" class="form-label  ">
                        Country
                    </label>
                    <select
                        class="form-select" disabled
                        id="country"
                    >
                        <option style={{ display: "none" }}> us
                        </option>
                        <option> us
                        </option>
                    </select>
                    </div>
                    <div class="mb-2 col-md-6 col-lg-4">
                <label for="completeddate" class="form-label  ">
                State
                </label>
                <input
                    type="text"disabled
                    class="form-control" value={stateName}
                    id="completeddate" 
                
                />
                </div>
                <div class="mb-2 col-md-6 col-lg-4">
                <label for="completeddate" class="form-label  ">
                City
                </label>
                <input
                    type="text"disabled
                    class="form-control" value={cityName}
                    id="completeddate" 
                
                />
                </div>
                <div class="mb-2 col-md-6 col-lg-4">
                <label for="completeddate" class="form-label  ">
                Zipcode
                </label>
                <input
                    type="text"disabled
                    class="form-control" value={zipcode}
                    id="completeddate" 
                
                />
                </div>
               
                </div>
            </div>
            <div className="CommonModalfooter ">
                            <div className="CommonModalfooter session">
                                <button className="cta-btn btn-smlprimary" onClick={props.toggle} >Close</button>
                                {/* <Button className="btn btn-smlprimary" onClick={()=> {saveAdd();props.toggle()}} >Ok</Button>  */}
                            </div> 
                            </div>   
            {/* <div class="text-center">
            <button type="button" class="btn btn-smloutline-danger me-2"
                data-bs-dismiss="modal" onClick={props.toggle}>Cancel</button>
            <button type="button"
                class="btn btn-smlprimary pe-3 ps-3 me-2" data-bs-toggle="modal"
                data-bs-target="#writeoff">Write Off</button>
         
                </div> */}
    </div>}

    </div>
  );
};

export default MailLogAdd;